import React from 'react'

const IntroVideo = () => {
  const [play, setPlay] = React.useState(false)
  const [loading, setLoading] = React.useState(false)

  const handlePlay = (e) => {
    e.preventDefault()

    // Manually trigger mouseleave to reset custom cursor (CustomCursor.js)
    // This is necessary because removing the element prevents the natural mouseleave from firing
    const mouseLeaveEvent = new MouseEvent('mouseleave', {
      view: window,
      bubbles: true,
      cancelable: true
    });
    e.currentTarget.dispatchEvent(mouseLeaveEvent);

    // Fallback: manually try to clean up cursor if the event doesn't catch
    const cursorEl = document.querySelector('.cb-cursor');
    const cursorTextEl = document.querySelector('.cb-cursor-text');
    if (cursorEl) cursorEl.classList.remove('-text');
    if (cursorTextEl) cursorTextEl.innerHTML = '';

    setLoading(true)
    // Small delay to ensure cursor resets before iframe takes over
    setTimeout(() => {
      setPlay(true)
      setLoading(false)
    }, 500)
  }

  return (
    <>
      {/* Intro Video Section Start */}
      <div className="intro-video">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* Intro Video Image Start */}
              <div className="intro-video-box">
                {!play && !loading ? (
                  <>
                    {/* Intro Image Start */}
                    <div className="intro-video-image">
                      <a
                        href="#!"
                        onClick={handlePlay}
                        className="popup-video"
                        data-cursor-text="Play"
                      >
                        <figure className="image-anime">
                          <img src="images/intro-video-bg.jpg" alt="Intro Video Background" />
                        </figure>
                      </a>
                    </div>
                    {/* Intro Image End */}

                    {/* Video Play Button Start */}
                    <div className="video-play-button">
                      <a
                        href="#!"
                        onClick={handlePlay}
                        className="popup-video"
                        data-cursor-text="Play"
                      >
                        play
                      </a>
                    </div>
                    {/* Video Play Button End */}
                  </>
                ) : loading ? (
                  /* Temporary state to clear cursor */
                  <div className="intro-video-image">
                    <figure className="image-anime">
                      <img src="images/intro-video-bg.jpg" alt="Intro Video Background" />
                    </figure>
                  </div>
                ) : (
                  <div className="video-iframe" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                    <iframe
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                      src="https://www.youtube.com/embed/pGoziKe0k5Y?si=cTRZETqRWRXKSuxs&autoplay=1&rel=0"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  </div>
                )}
              </div>
              {/* Intro Video Btn End */}
            </div>
          </div>
        </div>
      </div>
      {/* Intro Video Section End */}
    </>
  )
}

export default IntroVideo
